import React, { ReactNode, CSSProperties } from 'react';
import styles from '@/styles/modules/HStack.module.css';

interface HStackProps {
    children: ReactNode;
    spacing?: number | string;
    alignment?: 'start' | 'center' | 'end' | 'baseline' | 'stretch';
    justifyContent?: 'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly';
    wrap?: boolean;
    className?: string;
    style?: CSSProperties;
}

export const HStack: React.FC<HStackProps> = ({
    children,
    spacing = 12,
    alignment = 'center',
    justifyContent = 'start',
    wrap = false,
    className = '',
    style = {},
}) => {
    // Convert spacing to CSS value
    const spacingValue = typeof spacing === 'number' ? `${spacing}px` : spacing;

    // Use React.CSSProperties with custom property type assertion

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customStyle: React.CSSProperties & { [key: string]: any } = {
        '--hstack-spacing': spacingValue,
        alignItems: alignment === 'start' ? 'flex-start' :
            alignment === 'end' ? 'flex-end' : alignment,
        justifyContent: justifyContent === 'start' ? 'flex-start' :
            justifyContent === 'end' ? 'flex-end' : justifyContent,
        flexWrap: wrap ? 'wrap' : 'nowrap',
        ...style,
    };

    return (
        <div
            className={`${styles.hstack} ${className}`}
            style={customStyle}
        >
            {children}
        </div>
    );
};

export default HStack;

/*
Usage examples:
// Default spacing (12px)
<HStack>
  <button>Button 1</button>
  <button>Button 2</button>
  <button>Button 3</button>
</HStack>

// Custom spacing
<HStack spacing={20}>
  <div>Item 1</div>
  <div>Item 2</div>
</HStack>

// Using rem units
<HStack spacing="1.5rem">
  <span>Text</span>
  <span>More Text</span>
</HStack>

// Different alignment options
<HStack spacing={16} alignment="center" justifyContent="space-between">
  <div>Left</div>
  <div>Right</div>
</HStack>

// With wrapping
<HStack spacing={8} wrap={true}>
  <span>Tag 1</span>
  <span>Tag 2</span>
  <span>Tag 3</span>
</HStack>

*/